import { render, staticRenderFns } from "./DiagnosisStart.vue?vue&type=template&id=78b7b3f4&scoped=true&"
import script from "./DiagnosisStart.vue?vue&type=script&lang=js&"
export * from "./DiagnosisStart.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosisStart.vue?vue&type=style&index=0&id=78b7b3f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b7b3f4",
  null
  
)

export default component.exports